import { getClosestParent } from '@studiometa/js-toolkit';
import MapboxMap from './MapboxMap.js';

/**
 * withMapbox
 * @param {*} BaseClass
 * @returns {}
 */
export default function withMapbox(BaseClass) {
  return class extends BaseClass {
    /**
     * get map element
     * @returns {HTMLElement}
     */
    get map() {
      return getClosestParent(this, MapboxMap)?.map;
    }

    /**
     * getMapbox instance
     * @returns {object}
     */
    get mapbox() {
      return getClosestParent(this, MapboxMap)?.mapbox;
    }
  };
}
